import type { SubNavItem } from '../nav-bar/components/NavSubLink';

interface AffiliationNavItemLabels {
  programs: string;
  affiliates: string;
  invitations: string;
  commissions: string;
}

interface BuildAffiliationNavItemsOptions {
  labels: AffiliationNavItemLabels;
  affiliatesCount: number;
  pendingInvitations: number;
}

/**
 * The Affiliation group. Applications left it for a top-level "Candidatures"
 * entry, since briefs and programs are both applied to there. Commissions moved
 * in from the top level: they are what the affiliation programmes pay.
 */
export function buildAffiliationNavItems({
  labels,
  affiliatesCount,
  pendingInvitations,
}: BuildAffiliationNavItemsOptions): SubNavItem[] {
  return [
    { label: labels.programs, to: '/programs/browse' },
    {
      label: labels.affiliates,
      to: '/affiliates',
      exact: true,
      badge: affiliatesCount || undefined,
    },
    {
      label: labels.invitations,
      to: '/affiliates/invitations',
      badge: pendingInvitations || undefined,
    },
    { label: labels.commissions, to: '/payments/commissions' },
  ];
}
